import PropTypes from "prop-types";
import * as React from "react";
import get from "lodash/get";
import moment from "moment";
import { Interpolate, translate } from "react-i18next";
import { Icon, ContextMenu, ClanMember, MemberName, TableBodyCell, TableRow } from "@wg/wows-react-uikit";
import { Tooltip, TooltipBody } from "components";

import { StatisticsValue, RankCell } from "UIKit";

import { isoToFormattedLocalDate, isoToFormattedLocalDateTime, isoToFormattedLocalTime } from "helpers/datetime";
import { x } from "helpers/localization";
import { thousands, percent, floats } from "helpers/formatting";


const propTypes = {
  isCurrentClanFull: PropTypes.bool,
  invite: PropTypes.object.isRequired,
  hasActiveInviteForAccount: PropTypes.bool.isRequired,

  onSendInvite: PropTypes.func.isRequired,
  openAccountProfile: PropTypes.func.isRequired,
  openChatWindow: PropTypes.func.isRequired,

  t: PropTypes.func.isRequired
};

const getInviteStatusTooltipContent = invite => {
  let inviteStatusTooltip = null;

  const senderTooltipPart = (
    <Interpolate
      useDangerouslySetInnerHTML={true}
      i18nKey={x('%(senderMember)s отправил приглашение %(date)s&nbsp;в&nbsp;%(time)s')}
      senderMember={invite ? (<MemberName role={invite.sender.role} name={invite.sender.name} isInline />) : (<div />)}
      date={isoToFormattedLocalDate(invite.created_at)}
      time={isoToFormattedLocalTime(invite.created_at)}
      parent={'p'}
    />
  )

  const inClanCooldownTill = moment(invite.account.in_clan_cooldown_till).isAfter(moment().utc());
  if (inClanCooldownTill) {
    const cooldownAtDateTime = isoToFormattedLocalDateTime(invite.account.in_clan_cooldown_till);

    inviteStatusTooltip = <div>
      {senderTooltipPart}
      <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Игрок недавно покинул клан и сможет вступить в клан начиная c %(datetime)s')} datetime={cooldownAtDateTime} parent={'p'} />
      <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Время для принятия решения по приглашению истекает %(date)s&nbsp;в&nbsp;%(time)s')} date={isoToFormattedLocalDate(invite.expires_at)} time={isoToFormattedLocalTime(invite.expires_at)} parent={'p'} />
    </div>;
  } else if (invite.status === 'active') {
    inviteStatusTooltip = <div>
      {senderTooltipPart}
      <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Время для принятия решения по приглашению истекает %(date)s&nbsp;в&nbsp;%(time)s')} date={isoToFormattedLocalDate(invite.expires_at)} time={isoToFormattedLocalTime(invite.expires_at)} parent={'p'} />
    </div>;
  } else if (invite.status === 'expired') {
    inviteStatusTooltip = <div>
      <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Время для принятия решения истекло %(date)s&nbsp;в&nbsp;%(time)s')} date={isoToFormattedLocalDate(invite.expires_at)} time={isoToFormattedLocalTime(invite.expires_at)} parent={'p'} />
      {senderTooltipPart}
    </div>;
  } else if (invite.status === 'accepted') {
    inviteStatusTooltip = <div>
      <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Приглашение одобрено %(date)s&nbsp;в&nbsp;%(time)s')} date={isoToFormattedLocalDate(invite.updated_at)} time={isoToFormattedLocalTime(invite.updated_at)} parent={'p'} />
      {senderTooltipPart}
    </div>;
  } else if (invite.status === 'declined') {
    inviteStatusTooltip = <div>
      <Interpolate useDangerouslySetInnerHTML={true} i18nKey={x('Приглашение отклонено %(date)s&nbsp;в&nbsp;%(time)s')} date={isoToFormattedLocalDate(invite.updated_at)} time={isoToFormattedLocalTime(invite.updated_at)} parent={'p'} />
      {senderTooltipPart}
    </div>;
  }
  return inviteStatusTooltip;
};

class InvitesClanMemberTableItem extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isConextMenuActive: false,
      contextMenuContext: [],
      contextMenuPosition: { x: 0, y: 0 }
    };

    this.onContextMenuItemClick = this.onContextMenuItemClick.bind(this);
    this.onContextMenu = this.onContextMenu.bind(this);
    this.onContextMenuStateChange = this.onContextMenuStateChange.bind(this);
    this.onTableRowClick = this.onTableRowClick.bind(this);
  }

  onContextMenu(event) {
    this.setState({
      contextMenuContext: this.getContextMenuContext(),
      contextMenuPosition: {
        x: event.clientX,
        y: event.clientY
      }
    });
  }

  onContextMenuStateChange(isContextMenuActive) {
    this.setState({ isContextMenuActive });
  }

  getContextMenuContext() {
    const t = this.props.t;
    const account = this.props.invite.account;
    const hasPermanentBan = get(account, 'ban_info.type') === 'permanent' || !!this.props.invite.is_banned;
    const banMsg = hasPermanentBan ? t('Аккаунт игрока заблокирован') : null;
    const canSendInvite = !hasPermanentBan && !this.props.hasActiveInviteForAccount && !this.props.isCurrentClanFull;
    let sendInviteTooltip = null;
    if (hasPermanentBan) {
      sendInviteTooltip = banMsg;
    } else if (this.props.hasActiveInviteForAccount) {
      sendInviteTooltip = t('Приглашение уже отправлено');
    } else if (this.props.isCurrentClanFull) {
      sendInviteTooltip = t('В клане сейчас нет мест');
    }
    return [{
      name: null,
      items: [{
        name: t('Отправить сообщение'),
        value: 'ACCOUNT_MESSAGE',
        disabled: hasPermanentBan,
        tooltip: banMsg
      }, {
        name: t('Профиль игрока'),
        value: 'ACCOUNT_PROFILE',
        disabled: hasPermanentBan,
        tooltip: banMsg
      }, {
        name: t('Пригласить в клан'),
        disabled: !canSendInvite,
        tooltip: sendInviteTooltip,
        value: 'SEND_INVITE'
      }]
    }];
  }

  onContextMenuItemClick(action) {
    const account = this.props.invite.account;
    switch (action) {
      case 'ACCOUNT_PROFILE':
        this.props.openAccountProfile(account.id);
        break;
      case 'ACCOUNT_MESSAGE':
        this.props.openChatWindow(account.id, account.name);
        break;
      case 'SEND_INVITE':
        this.props.onSendInvite(account);
        break;

    }
  }

  onTableRowClick() {
    const account = this.props.invite.account;
    this.props.openChatWindow(account.id, account.name);
  }

  render() {
    const {
      invite
    } = this.props;
    const isHiddenStatistics = invite.is_hidden_statistics;

    const inviteStatusTooltipId = `invite-status-tooltip-${invite.id}`;
    const inviteStatusTooltip = getInviteStatusTooltipContent(invite);

    const tooltipStatus = (inviteStatusTooltip && !this.state.isContextMenuActive) ? <Tooltip id={inviteStatusTooltipId}>
      <TooltipBody>{inviteStatusTooltip}</TooltipBody>
    </Tooltip> : null;

    return <TableRow isHovering isActive={this.state.isContextMenuActive} onContextMenu={this.onContextMenu} onClick={this.onTableRowClick}>
      <ContextMenu context={this.state.contextMenuContext} position={this.state.contextMenuPosition} onItemClick={this.onContextMenuItemClick} onContextMenuStateChange={this.onContextMenuStateChange} />
      <TableBodyCell modify="basis">
        <ClanMember id={invite.account.id} name={invite.account.name} rank={invite.statistics.rank} seasonId={invite.statistics.season_id} seasonRank={invite.statistics.season_rank} hasPermanentBan={get(invite, 'account.ban_info.type') === 'permanent' || !!invite.is_banned} disableTooltip={this.state.isContextMenuActive} leftMouseAction="send_message" hasContextMenu />
      </TableBodyCell>
      <TableBodyCell modify="small">
        <RankCell id={invite.account.id} rank={invite.statistics.rank} seasonId={invite.statistics.season_id} seasonRank={invite.statistics.season_rank} disableTooltip={this.state.isContextMenuActive} />
      </TableBodyCell>
      <TableBodyCell modify="right">
        <StatisticsValue value={thousands(invite.statistics.btl)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
      </TableBodyCell>
      <TableBodyCell modify="right">
        <StatisticsValue value={percent(invite.statistics.wb)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
      </TableBodyCell>
      <TableBodyCell modify="right">
        <StatisticsValue value={thousands(invite.statistics.aeb)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
      </TableBodyCell>
      <TableBodyCell modify="right">
        <StatisticsValue value={thousands(invite.statistics.admg)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
      </TableBodyCell>
      <TableBodyCell modify="right">
        <StatisticsValue value={floats(invite.statistics.afb, 2)} isHidden={isHiddenStatistics} disableTooltip={this.state.isContextMenuActive} />
      </TableBodyCell>
      <TableBodyCell modify="right">
        <div data-for={inviteStatusTooltipId} data-tip>
          <Icon glyph={`status-${invite.status}`} />
          {tooltipStatus}
        </div>
      </TableBodyCell>
    </TableRow>;
  }
}

InvitesClanMemberTableItem.propTypes = propTypes;

export default translate()(InvitesClanMemberTableItem);